export default "/storefront/client/images/Frame.png";